<template>
  <svg :width="width" :height="height" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18 21L14 17H17V7H14L18 3L22 7H19V17H22L18 21Z" :fill="iconColor"/>
    <path d="M2 5V7H12V5H2ZM2 11V13H9V11H2ZM2 17V19H6V17H2Z" :fill="iconColor"/>
  </svg>
</template>

<script>
export default {
  props: {
    iconName: {
      type: String,
      default: "iconSortUp",
    },
    width: {
      type: [Number, String],
      default: 24,
    },
    height: {
      type: [Number, String],
      default: 24,
    },
    iconColor: {
      type: String,
      default: "currentColor",
    },
  },
};
</script>
